module.exports = __webpack_public_path__ + "static/media/wolf-fox.0ab7beba.jpg";